<template>
  <div v-if="showStatus" class="inspection-status">
    <v-layout class="status-container">
      <v-flex>
        <v-layout class="header">
          <v-flex class="title">
            <h2>{{currentStep.title}}</h2>
          </v-flex>
          <v-flex class="status">
            <v-stepper
              v-if="showStepper"
              :value="currentStep.step"
              alt-labels
              class="stepper">
              <v-stepper-header>
              <template v-for="step in steps">
                <v-stepper-step
                  color="orange lighten-1"
                  :step="step.step"
                  :complete="step.step < currentStep.step"
                  :key="`${step.step}-step`">{{step.title}}</v-stepper-step>
                <v-divider
                  :class="{'completed-divider' : step.step < currentStep.step }"
                  v-if="step.step !== steps.length"
                  :key="step.step"></v-divider>
              </template>
              </v-stepper-header>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-layout class="action">
          <v-flex>
            <p>{{currentStep.description}}</p>
            <hg-inspection-status-link
              :hg-current-step="hgFolderStatus.workflow.currentStep"
              :hg-folder-id="hgFolderId"
              :hg-company-id="hgCompanyId"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import InspectionStatusLink from './InspectionStatusLink.vue';

export default {
  props: {
    hgFolderStatus: {
      type: Object,
      required: true,
    },
    hgFolderId: {
      type: String,
      required: true,
    },
    hgCompanyId: {
      type: Number,
      required: true,
    },
  },
  components: {
    'hg-inspection-status-link': InspectionStatusLink,
  },
  computed: {
    workflow() {
      return this.hgFolderStatus.workflow || [];
    },
    steps() {
      return this.workflow.steps;
    },
    showStepper() {
      return this.workflow.steps.length > 1;
    },
    currentStep() {
      return this.workflow.currentStep;
    },
    showStatus() {
      return Object.keys(this.workflow).length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

.inspection-status {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 45px;
}

.status-container {
  box-shadow: none;
  flex-direction: column;
  height: auto !important;
}

.v-stepper,
p,
h2 {
  box-shadow: none;
}

.title {
  flex: 0 0 300px;
}

h2 {
  font-family: $typography-font-secondary;
}

.action {
  flex: 0 0 50px;
  padding: 10px;
  text-align: center;

  p {
    display: inline-block;
    font-size: 1.143rem;
  }
}

.header {
  flex: 0 0 100px;
}

.completed-divider {
  border-top: solid 3px $theme-color-primary;
}

@media all and (max-width: 655px) {
  .inspection-status {
    border: solid 1px rgba(0, 0, 0, 0.15);
    margin: 0 30px 30px;
    padding: 50px 20px 40px 20px;
  }
}

@media all and (max-width: 950px) {
  .status {
    display: none;
  }

  .header {
    flex-direction: column;
    text-align: center;
  }

  .title {
    flex: 1 1 auto;
  }

  .action {
    margin-top: 20px;

    a {
      margin: 0;
      max-width: 100%;
      padding-bottom: 10px;
      padding-top: 10px;
    }

    .flex {
      align-items: center;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>

<style lang="scss">
@import '../../../styles/vars/typography';

.inspection-status {
  .v-stepper__label {
    font-family: $typography-font-secondary;
    font-size: 0.857rem;
    text-transform: uppercase;
  }
  .theme--light .v-stepper .v-stepper__step--complete .v-stepper__label,
  .theme--light .v-stepper .v-stepper__step--active .v-stepper__label {
    font-weight: $typography-weight-bold;
  }
}

.theme--light .v-stepper {
  background: none !important;
}
</style>
